import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { provideRouter, Routes } from '@angular/router';
import { CheckboxConfig, DEFAULT_CHECKBOX_CONFIG } from './checkbox.modal';

@Component({
  selector: 'ds-checkbox',
  templateUrl: './checkbox.component.html',
  standalone: true,
})
export class CheckboxComponent {
  public _checkboxInput: CheckboxConfig = { ...DEFAULT_CHECKBOX_CONFIG };
  @Input() checkboxInput!: CheckboxConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.checkboxInput) {
      const val: CheckboxConfig = changes.checkboxInput.currentValue || {};
      this.checkboxInput = { ...DEFAULT_CHECKBOX_CONFIG, ...val };
    }
  }

  @Output() checkedChange = new EventEmitter<boolean>();

  onClick(event: Event) {
    const input = event.target as HTMLInputElement;
    // update internal state so UI reflects the change immediately
    this.checkboxInput.isSelected = !!input.checked;
    this.checkedChange.emit(input.checked);
  }
}